import { createSlice } from '@reduxjs/toolkit'
import courseApi from 'src/api/course'

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,
  details:null,
  detail: {
    id: null,
    total: 0,
    courseProducts: [],
    paid: 0,
    paymentHistories: [],
  },
}

const slice = createSlice({
  name: 'order_detail',
  initialState,
  reducers: {
    createOrderProduct(oldState, action) {
      let courseProduct = action.payload


      let courseProducts = [...oldState.detail.courseProducts, courseProduct]

      const total =
        courseProducts && courseProducts.length > 0
          ? courseProducts.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

      // courseProduct = action.payload
      // courseProduct.actualPriceEach =
      //   courseProduct.amount == 0
      //     ? 0
      //     : courseProduct.actualPriceTotal / courseProduct.amount
      
      oldState.detail = {
        ...oldState.detail,
        total: total,
        courseProducts: courseProducts,
      }
    },
    createOrderProducts(oldState, action) {
      let courseProduct = action.payload


      let courseProducts = [...courseProduct]

      const total =
        courseProducts && courseProducts.length > 0
          ? courseProducts.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

      // courseProduct = action.payload
      // courseProduct.actualPriceEach =
      //   courseProduct.amount == 0
      //     ? 0
      //     : courseProduct.actualPriceTotal / courseProduct.amount
      
      oldState.detail = {
        ...oldState.detail,
        total: total,
        courseProducts: courseProducts,
      }
    },
    updateOrderProduct(oldState, action) {
      const courseProduct = action.payload
      let courseProducts = [...oldState.detail.courseProducts]
      const idx = courseProducts.findIndex((cp) => cp.id === courseProduct.id)

      courseProducts = [
        ...courseProducts.slice(0, idx),
        courseProduct,
        ...courseProducts.slice(idx + 1, courseProducts.length),
      ]

      const total =
        courseProducts && courseProducts.length > 0
          ? courseProducts.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

      oldState.detail = {
        ...oldState.detail,
        total: total,
        courseProducts: courseProducts,
      }
    },

    deleteOrderProduct(oldState, action) {
      const courseProduct = action.payload
      let courseProducts = [...oldState.detail.courseProducts]
      const idx = courseProducts.findIndex((cp) => cp.id === courseProduct.id)

      courseProducts = courseProducts
        .slice(0, idx)
        .concat(courseProducts.slice(idx + 1, courseProducts.length))

      const total =
        courseProducts && courseProducts.length > 0
          ? courseProducts.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

      oldState.detail = {
        ...oldState.detail,
        total: total,
        courseProducts: courseProducts,
      }
    },

    createOrderPayment(oldState, action) {
      const payment = action.payload
      const paymentHistories = [...oldState.detail.paymentHistories, payment]

      const id =
        (paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((max, curr) =>
              max.id > curr.id ? max : curr
            ).id
          : 0) + 1

      const paid =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.amount, 0)
          : 0

      const afterTax =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.afterTax, 0)
          : 0

      payment.id = id

      oldState.detail = {
        ...oldState.detail,
        paid: paid,
        afterTax: afterTax,
        paymentHistories: [...paymentHistories],
      }
    },


    updateOrderPayment(oldState, action) {
      const payment = action.payload
      let paymentHistories = [...oldState.detail.paymentHistories]

      const idx = paymentHistories.findIndex((p) => p.id === payment.id)

      paymentHistories = [
        ...paymentHistories.slice(0, idx),
        payment,
        ...paymentHistories.slice(idx + 1, paymentHistories.length),
      ]
      const paid =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.amount, 0)
          : 0

      const afterTax =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.afterTax, 0)
          : 0

      oldState.detail = {
        ...oldState.detail,
        paid: paid,
        afterTax: afterTax,
        paymentHistories: [...paymentHistories],
      }
    },

    deleteOrderPayment(oldState, action) {
      const payment = action.payload
      let paymentHistories = [...oldState.detail.paymentHistories]

      const idx = paymentHistories.findIndex((ph) => ph.id === payment.id)

      paymentHistories = paymentHistories
        .slice(0, idx)
        .concat(paymentHistories.slice(idx + 1, paymentHistories.length))

      const paid =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.amount, 0)
          : 0

      const afterTax =
        paymentHistories && paymentHistories.length > 0
          ? paymentHistories.reduce((acc, curr) => acc + +curr.afterTax, 0)
          : 0

      oldState.detail = {
        ...oldState.detail,
        paid: paid,
        afterTax: afterTax,
        paymentHistories: [...paymentHistories],
      }
    },

    setCourseDetail(oldState, action) {
      let data=action.payload     
      let product= data.courseProducts.map((pro,index) =>{
        return {
        productInputDisplay :
        pro.packages==null ?pro.product.category.name +
        '-' +
        pro.product.name:pro.packages.category.name +
        '-' +
        pro.packages.name,
      product: pro.product,
      productId: pro.product==null? null:pro.product.id,
      id: pro.id,
      index: index,
      amount: pro.amount,
      actualPriceEach: pro.actualPriceEach,
      actualPriceTotal: pro.actualPriceTotal,
      defaultOperatorId: pro.defaultOperator.id,
      defaultOperator: pro.defaultOperator,
      packages:pro.packages,
      packageId: pro.packages==null ? null:pro.packages.id,
      packagePrice: pro.packagePrice}
      })
      
      let courseId=data.id
      let payment = data.paymentHistories.map((pay,index) =>{
        return{
            id: pay.id,
            afterTax: pay.afterTax,
            amount: pay.amount,
            comment: pay.comment,
            courseId: courseId,
            info: pay.info,
            paymentMethodId: pay.paymentMethod.id,
            paymentMethod: pay.paymentMethod,
            recordDateTime: pay.recordDateTime,
            tax:pay.tax,
            splitCashInSet: pay.splitCashInSet.map(
                (sp) => {
                    return {
                        amount: +sp.amount,
                        cashInId: sp.cashInId,
                        courseProductId:sp.courseProduct !=null ? sp.courseProduct.id : null,
                        courseProduct:sp.courseProduct,
                        category:sp.category,
                        employeeId: sp.employee.id,
                        employee: sp.employee,
                    }
                }
            ),
        }})

      const total =
      product && product.length > 0
          ? product.reduce(
              (acc, curr) => acc + +curr.actualPriceTotal,
              0
            )
          : 0

          const paid =
          payment && payment.length > 0
              ? payment.reduce((acc, curr) => acc + +curr.amount, 0)
              : 0
    
          const afterTax =
          payment && payment.length > 0
              ? payment.reduce((acc, curr) => acc + +curr.afterTax, 0)
              : 0

      oldState.details=data
      oldState.detail = {
        ...oldState.detail,
        total: total,
        paid: paid,
        afterTax: afterTax,
        courseProducts: [...product],
        paymentHistories: [...payment],
      }
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },

    reset(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
      oldState.details=null
      oldState.detail = {
        id: null,
        total: 0,
        courseProducts: [],
        paid: 0,
        paymentHistories: [],
      }
    },
  },
})

export const reducer = slice.reducer

export const setOrderDetail = (detail) => (dispatch) => {
  dispatch(slice.actions.setOrderDetail(detail))
}

// product
export const createOrderProduct = (courseProduct) => (dispatch) => {
  dispatch(slice.actions.createOrderProduct(courseProduct))
}

export const createOrderProducts = (courseProduct) => (dispatch) => {
  dispatch(slice.actions.createOrderProducts(courseProduct))
}

export const updateOrderProduct = (courseProduct) => async (dispatch) => {
  dispatch(slice.actions.updateOrderProduct(courseProduct))
}

export const deleteOrderProduct = (courseProduct) => async (dispatch) => {
  dispatch(slice.actions.deleteOrderProduct(courseProduct))
}

// payment
export const createOrderPayment = (payment) => (dispatch) => {
  dispatch(slice.actions.createOrderPayment(payment))
}


export const updateOrderPayment = (payment) => async (dispatch) => {
  dispatch(slice.actions.updateOrderPayment(payment))
}

export const deleteOrderPayment = (payment) => async (dispatch) => {
  dispatch(slice.actions.deleteOrderPayment(payment))
}

// Reload
export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

// Modal
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const resetOlderSlice = () => (dispatch) => {
  dispatch(slice.actions.reset())
}

export const getOrderDetailById = (id) => async (dispatch) => {
  const detail = await courseApi.findCourseById(id)
  dispatch(slice.actions.setCourseDetail(detail))
}

export default slice
